// extracted by mini-css-extract-plugin
export default {"ConstructorPage":"Constructor_ConstructorPage__3P6aj"};